<template>
    <Multiselect v-bind="attrs" v-on="listeners">
        <template v-for="slotName in Object.keys($slots)" #[slotName]>
            <slot :name="slotName"></slot>
        </template>
        <template v-for="slotName in Object.keys($scopedSlots)" #[slotName]="slotProps">
            <slot :name="slotName" v-bind="slotProps"></slot>
        </template>
        <template slot="selection" slot-scope="{ values, isOpen }">
            <span v-if="values.length && !isOpen" class="multiselect__single">{{ $t('campaigns') }} ({{ values.length }})</span>
        </template>
        <template slot="selectAllHeader" slot-scope="{ values }">
            {{ $t('campaigns') }} ({{ values.length }})
        </template>
    </Multiselect>
</template>



<script>
    import Multiselect from '@/components/common/Multiselect.vue';
    import spaceService from '@/services/spaceService';
    import campaignsService from '@/services/campaignsService';

    export default {
        name: 'MultiselectCampaigns',
        inheritAttrs: false,
        components: {
            Multiselect,
        },
        props: {
            lazy: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                searchText: '',
            };
        },
        computed: {
            attrs() {
                return {
                    'show-checkboxes': true,
                    'clear-on-select': false,
                    'close-on-select': false,
                    'show-selected': true,
                    'show-selected-on-top': true,
                    'fetch-options-function': this.fetchCampaigns,
                    'parse-options-function': this.parseOptions,
                    trackBy: 'id',
                    label: 'name',
                    class: 'mb-0',
                    multiple: true,
                    placeholder: this.$t('campaigns'),
                    asynchronous: false,
                    trackByLabel: this.$t('id'),
                    ...this.$attrs,
                };
            },
            listeners() {
                return {
                    ...this.$listeners,
                    input: (value, id) => {
                        if (!this.lazy) this.$emit('input', value, id);
                    },
                    change: (value, id) => {
                        this.$emit('input', value, id);
                        this.$emit('change', value, id);
                    },
                    'search-change': (search, id) => {
                        this.searchText = search;
                        this.$emit('searchChange', search, id);
                    },
                };
            },
            isRoleAdvertiser() {
                return this.$store.getters['auth/isRoleAdvertiser'];
            },
        },
        methods: {
            parseOptions(data) {
                return Object.values(data?.items || {}).sort((a, b) => a.name.localeCompare(b.name));
            },
            fetchCampaigns() {
                if (this.isRoleAdvertiser) return campaignsService.getAdvertiserCampaigns({ userId: this.$store.getters['auth/userId'] });
                return spaceService.fetchCampaigns({ userRole: 'admin' });
            },
        },
    };
</script>
